import React from 'react'
import { IconButton, Grid, Tooltip } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import { useLang } from '~/hooks/useLang'
import useDispatchState from '~/features/Dispatch/stores/DispatchState'

interface PreviousNavegationButtonProps {
  readonly hasPrevious?: boolean
  readonly previous?: VoidFunction
  readonly loadingDispatchForm?: boolean
  readonly id: number
}

export default function PreviousNavegationButton({
  hasPrevious,
  previous,
  id
}: PreviousNavegationButtonProps) {
  const { translate } = useLang()
  const isDisabled = !hasPrevious


  return (
    <Grid item>
      <Tooltip
        title={translate('Previous')}
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton
            disabled={isDisabled || !id}
            onClick={() => (previous ? previous() : false)}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Grid>
  )
}
